import { Badge } from "../components/ui/badge";
import { 
  Clock, 
  CheckCircle2, 
  XCircle, 
  ShieldCheck, 
  FileText,
  AlertCircle
} from "lucide-react";

const statusConfig = {
  draft: { label: "Draft", icon: FileText, className: "bg-slate-100 text-slate-700 border-slate-200" },
  submitted: { label: "Submitted", icon: Clock, className: "bg-amber-50 text-amber-700 border-amber-200" },
  pending_coordinator: { label: "Pending Coordinator", icon: Clock, className: "bg-amber-50 text-amber-700 border-amber-200" },
  pending_principal: { label: "Pending Principal", icon: Clock, className: "bg-amber-50 text-amber-700 border-amber-200" },
  pending_vp_as_coordinator: { label: "Pending VP (as Coordinator)", icon: Clock, className: "bg-amber-50 text-amber-700 border-amber-200" },
  pending_vp_as_principal: { label: "Pending VP (as Principal)", icon: Clock, className: "bg-amber-50 text-amber-700 border-amber-200" },
  pending_hostel_warden: { label: "Pending Warden", icon: Clock, className: "bg-amber-50 text-amber-700 border-amber-200" },
  rejected_coordinator: { label: "Rejected by Coordinator", icon: XCircle, className: "bg-red-50 text-red-700 border-red-200" },
  rejected_principal: { label: "Rejected by Principal", icon: XCircle, className: "bg-red-50 text-red-700 border-red-200" },
  rejected_vp: { label: "Rejected by VP", icon: XCircle, className: "bg-red-50 text-red-700 border-red-200" },
  rejected_warden: { label: "Rejected by Warden", icon: XCircle, className: "bg-red-50 text-red-700 border-red-200" },
  approved: { label: "Approved", icon: CheckCircle2, className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  printed: { label: "Printed", icon: FileText, className: "bg-blue-50 text-blue-700 border-blue-200" },
  gate_verified: { label: "Gate Verified", icon: ShieldCheck, className: "bg-blue-50 text-blue-700 border-blue-200" },
  closed: { label: "Closed", icon: CheckCircle2, className: "bg-slate-100 text-slate-700 border-slate-200" },
};

export const StatusBadge = ({ status }) => {
  const config = statusConfig[status] || { 
    label: status, 
    icon: AlertCircle, 
    className: "bg-slate-100 text-slate-700 border-slate-200" 
  };
  const Icon = config.icon;

  return (
    <Badge 
      variant="outline" 
      className={`${config.className} font-medium`}
      data-testid={`status-badge-${status}`}
    >
      <Icon className="w-3 h-3 mr-1" />
      {config.label}
    </Badge>
  );
};

const passTypeLabels = {
  short_leave: "Short Leave",
  day_pass: "Day Pass",
  emergency_leave: "Emergency Leave",
  home_visit: "Home Visit",
  medical_leave: "Medical Leave",
  other: "Other",
};

export const PassTypeBadge = ({ type }) => {
  return (
    <Badge variant="secondary" className="font-medium" data-testid={`pass-type-badge-${type}`}>
      {passTypeLabels[type] || type}
    </Badge>
  );
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  return new Date(dateStr).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return "-";
  return new Date(dateStr).toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
